import { Component, Input, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';

@Component({
  standalone: true,
  selector: 'sbi-copy-field',
  templateUrl: './copy-field.component.html',
  styleUrls: ['./copy-field.component.scss'],
  imports: [CommonModule, OverlayModule],
})
export class CopyFieldComponent {
  @Input() value: string = '';

  public isCopied = false;

  // Tooltip renders in a CDK overlay (attached to <body>), not inside the
  // table cell — table containers clip/scroll their content, so a normal
  // absolutely-positioned child gets cropped or painted behind other rows
  // regardless of z-index. The overlay also auto-flips to the second
  // position when the first one doesn't fit the viewport (e.g. near the
  // sticky header), so no manual collision math is needed.
  public readonly overlayPositions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -6,
    },
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: 6,
    },
  ];

  constructor(private _ngZone: NgZone) {}

  public onCopy(event: Event): void {
    event.stopPropagation();
    if (!this.value || this.value === '-') return;
    navigator.clipboard.writeText(this.value).then(() => {
      this._ngZone.run(() => {
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 800);
      });
    });
  }
}
